<script lang="ts">
    import ToastContainer from "../Toasts/ToastContainer.svelte";
    import { mercadologicaPostItStore } from "../../Stores/MercadologicaPostItStore";
    import { toastStore } from "../../Stores/ToastStoreSingleton";

    export let senderName: string;
    export let message: string;
    export let toastUuid = "";
    export let duration = 10000;

    function openPostIts(): void {
        mercadologicaPostItStore.openInbox();

        if (toastUuid) {
            toastStore.removeToast(toastUuid);
        }
    }
</script>

<ToastContainer
    extraClasses="w-full min-w-72 max-w-sm sm:min-w-80 sm:max-w-md"
    {toastUuid}
    {duration}
    theme="secondary"
>
    <button
        type="button"
        class="flex w-full items-center gap-3 rounded-lg bg-transparent p-0 text-left text-white"
        onclick={openPostIts}
    >
        <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-yellow-300 text-2xl shadow">
            📝
        </div>

        <div class="min-w-0 flex-1">
            <div class="font-bold">Novo recado de {senderName}</div>
            <div class="mt-1 truncate text-sm opacity-90">{message}</div>
            <div class="mt-1 text-xs font-bold text-yellow-200">Clique para abrir</div>
        </div>
    </button>
</ToastContainer>
